import { device } from 'helpers/screenSizes';
import MediaQuery from 'react-responsive';
import { DeltaIndiaLogoMobile, DeltaLogoMobile } from 'styles/assets/icons';
import DeltaExchange from 'styles/assets/icons/DeltaExchange';
import DemoBadge from '.';
import styles from './index.module.scss';

const DeltaIndiaDemoLogo = () => {
  return (
    (<div className={styles.demoLogoContainer} data-palette="DeltaIndiaDemoLogo">
      <DeltaIndiaLogoMobile />
      <MediaQuery query={device.up.lg}>
        <DeltaExchange />
      </MediaQuery>
      <DemoBadge />
    </div>)
  );
};

const DeltaGlobalDemoLogo = () => {
  return (
    (<div className={styles.demoLogoContainer} data-palette="DeltaGlobalDemoLogo">
      <DeltaLogoMobile />
      <MediaQuery query={device.up.lg}>
        <DeltaExchange />
      </MediaQuery>
      <DemoBadge />
    </div>)
  );
};

export { DeltaGlobalDemoLogo, DeltaIndiaDemoLogo };

